import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorLabel: {
		id: 'issue-field-validation-popup.validation-popper.popup-content.error-label',
		defaultMessage: 'Error',
		description: 'Label shown for the validation message error icon.',
	},
	warningLabel: {
		id: 'issue-field-validation-popup.validation-popper.popup-content.warning-label',
		defaultMessage: 'Warning',
		description: 'Label shown for the validation message warning icon.',
	},
});
export default messages;
